module.exports = __webpack_public_path__ + "img/FZLC_9.cb0cbf39.jpg";